/** Question-prompt placeholder: one tall bar on the primary surface. */

import { createThemedStyles } from '@repo/theme/styles';
import { spacings } from 'component/constants';
import { View } from 'react-native';

import { BaseSkeleton } from './base-skeleton';

export function PromptSkeleton() {
    const s = usePromptSkeletonStyles();
    return (
        <View style={s.container}>
            <BaseSkeleton borderRadius={spacings.xs} height={50} width='100%' />
        </View>
    );
}

const usePromptSkeletonStyles = createThemedStyles((tokens) => ({
    container: {
        paddingTop: spacings.xl2,
        paddingHorizontal: 20,
        paddingBottom: spacings.md,
        backgroundColor: tokens.colors.colorSurfacePrimary,
    },
}));
